import moment from 'moment';
import _ from 'lodash';

const resolvePeriodFormat = (p) => {
  switch (p) {
    // case 'Point': return 'YYYY-MM-DDTHH:mm:ss+00:00';
    case 'Minute':
      return 'YYYY-MM-DDTHH:mm:00+00:00';
    case 'Hourly':
      return 'YYYY-MM-DDTHH:00:00+00:00';
    case 'Daily':
      return 'YYYY-MM-DDT00:00:00+00:00';
    case 'Weekly':
      return 'YYYY-MM-DDT00:00:00+00:00';
    case 'Monthly':
      return 'YYYY-MM-01T00:00:00+00:00';
    case 'Annual':
      return 'YYYY-01-01T00:00:00+00:00';
    default:
      return 'YYYY-MM-DDTHH:mm:ss+00:00';
  }
};

export default (observations, period, startTime, aggregationType) => {
  return _.groupBy(observations, item => {
    if (period == 'Daily') {
      let date = item[0],
        hour = new Date(date).getUTCHours(),
        minute = new Date(date).getUTCMinutes(),
        startHour = +startTime[0],
        startMinute = +startTime[1],
        offSetHour = Math.floor(moment().utcOffset() / 60),
        offSetMinute = moment().utcOffset() % 60;

      if (hour !== 0 && minute !== 0 && ((hour < (startHour)) || (hour == (startHour) && minute < (startMinute)))) {
        return moment.utc(moment.utc(date).subtract(1, 'days').format('YYYY-MM-DDT00:00:00+00:00')).add(startHour, 'hours').add(startMinute, 'minutes').format('YYYY-MM-DDTHH:mm:00+00:00')
      } else {
        return moment.utc(moment.utc(date).format('YYYY-MM-DDT00:00:00+00:00')).add(startHour, 'hours').add(startMinute, 'minutes').format('YYYY-MM-DDTHH:mm:00+00:00')
      }
    } else if (period == 'Seasonal') {
      // 12 1 2, 3 4 5, 6 7 8 9, 10 11
      let date = moment.utc(item[0]).format('YYYY-MM-DDTHH:mm:ss'),
        year = +date.split('-')[0],
        month = +date.split('-')[1],
        periodYear = month === 1 || month === 2 ? year - 1 : year,
        periodMonth = (() => {
          switch(month){
            case 12: return 12; // dev
            case 1: return 12;  // jan
            case 2: return 12;  // feb
            case 3: return 3;   // mar
            case 4: return 3;   // apr
            case 5: return 3;   // may
            case 6: return 6;   // june
            case 7: return 6;   // july
            case 8: return 6;   // aug
            case 9: return 6;   // sept
            case 10: return 10; // oct
            case 11: return 10; // nov
            default: return null;
          }
        })();
      let period = moment().year(periodYear).month(periodMonth - 1).format('YYYY-MM-01T00:00:00');
      // if(month == 12) console.log(date, year, month, periodYear, periodMonth, period)
      return period;
    } else if (period == 'Weekly') {
      let date = moment.utc(item[0]).format('YYYY-MM-DDTHH:mm:ss'),
        year = +date.split('-')[0],
        month = +date.split('-')[1],
        doy = moment.utc(date).dayOfYear();

      if (year % 4 === 0 && month > 2) doy--;

      let week = Math.floor((doy - 1) / 7) + 1;

      if (week > 52) week = 52;

      let periodDoy = ((week - 1) * 7) + 1;
      if (year % 4 === 0 && month > 2) periodDoy++;

      return moment().year(year).dayOfYear(periodDoy).format('YYYY-MM-DDT00:00:00');
    } else {
      if (aggregationType === 1) return moment.utc(moment.utc(item[0])).format(resolvePeriodFormat(period, moment.utc(item[0])));
      else {
        let timeUnit = (() => {
          switch (period) {
            case 'Minute': return 'minutes';
            case 'Hourly': return 'hours';
            case 'Daily': return 'days';
            case 'Monthly': return 'months';
            case 'Annual': return 'years';
            default: return null;
          }
        })()
        if (!timeUnit) return moment.utc(moment.utc(item[0])).format(resolvePeriodFormat(period, moment.utc(item[0])));
        else return moment.utc(moment.utc(item[0])).subtract(1, 'seconds').add(1, timeUnit).format(resolvePeriodFormat(period, moment.utc(item[0])));
      }
    }
  });
}


// WEBPACK FOOTER //
// ./src/libs/periodDataCategorize.js